import { render, staticRenderFns } from "./Sim-web.vue?vue&type=template&id=c7495cf8&scoped=true"
import script from "./Sim-web.vue?vue&type=script&lang=js"
export * from "./Sim-web.vue?vue&type=script&lang=js"
import style0 from "./Sim-web.vue?vue&type=style&index=0&id=c7495cf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7495cf8",
  null
  
)

export default component.exports